export default __webpack_public_path__ + "static/media/care.b1f2ffbf.png";